import React, { useState, useEffect } from "react";
import { Button, Modal, Result, Spin } from "antd";
import { useSendMsgMutation } from "../../redux/onco/onco";
import { InfoCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";

function SendVerify({ vrData, vrOpen, vrClose }) {
  const [sendMsg, { isLoading, data }] = useSendMsgMutation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const alertMsg = data?.token;

  const onFinish = async () => {
    await sendMsg(vrData);
    setIsModalOpen(true);
  };
  const handleOK = () => {
    setIsModalOpen(false);
    window.location.reload(false);
  };
  const handleCancel = () => {
    vrClose(false);
  };
  return (
    <div className="verify">
      <Modal
        title=""
        open={isModalOpen}
        closeIcon={false}
        okButtonProps={{
          hidden: true,
        }}
        cancelButtonProps={{
          hidden: true,
        }}
      >
        <Result
          status="success"
          title="Sizning arizangiz qabul qilindi!"
          subTitle={`Ariza raqami ${alertMsg}`}
          extra={[
            <Button type="primary" key="console" onClick={handleOK}>
              ok
            </Button>,
          ]}
        />
      </Modal>
      <Modal
        title=""
        open={vrOpen}
        okButtonProps={{
          hidden: true,
        }}
        cancelButtonProps={{
          hidden: true,
        }}

        closable={true}
        onCancel={handleCancel}
      >
        <Spin spinning={isLoading}>
          <div className="verify__icon">
            <InfoCircleOutlined className="iconVr" />
            <h3>Tasdiqlang</h3>
          </div>
          <div className="verify__data">
            <h6>F.I.SH:</h6> <p>{vrData?.surname + " " + vrData?.name}</p>
          </div>
          <div className="verify__data">
            <h6>Bo`lim:</h6> <p>{vrData?.department}</p>
          </div>
          <div className="verify__data">
            <h6>Muammo:</h6> <p>{vrData?.problem}</p>
          </div>
          <div className="verify__data">
            <h6>Xona raqami:</h6> <p>{vrData?.roomNumber}</p>
          </div>
          <div className="verify__data">
            <h6>Telefon raqami:</h6> <p>{vrData?.phoneNumber}</p>
          </div>

          <button onClick={onFinish} className="verify__button">
            Tasdiqlash
          </button>
        </Spin>
      </Modal>
    </div>
  );
}

export default SendVerify;
